import { render, staticRenderFns } from "./CameraDialog.vue?vue&type=template&id=90211ed4&lang=pug&"
import script from "./CameraDialog.vue?vue&type=script&lang=ts&"
export * from "./CameraDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports